import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-text',
  template: require('./nbinput-text.component.html'),
  styles: [require('./nbinput-text.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputTextComponent),
      multi: true
    }
  ]
})

export class NbinputTextComponent implements ControlValueAccessor {
  public FieldType = NbFieldType;
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(obj: string): void {this.data = obj;}

  public disabled = false;
  @Input()
  public readonly = false;

  onBlur() { this.onTouchedCallback(); }
  @Input()
  data:string;
  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }

  @Input()
  type:NbFieldType = NbFieldType.Text;
  @Input()
  placeholder:string = '';

  @Output() public onSubmit: EventEmitter<any> = new EventEmitter();
  onChange(event){
    this.onSubmit.emit(this.data);
    this.onChangeCallback(this.data);
  }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-text.component.ts